import { ApolloError, DocumentNode, FetchResult, TypedDocumentNode, useMutation } from "@apollo/client";
import { useCallback } from "react";

import { FieldworkerUpdateMutation, GqlFieldworkerUpdateInput, gql } from "~/__generated__";
import { ME_GET_USER_INFO } from "~/modules/auth/api/useMeGetUserInfoQuery";

export const FIELDWORKER_UPDATE = gql(`
mutation FieldworkerUpdate($input: GqlFieldworkerUpdateInput!) {
  fieldworkerUpdate(input: $input) {
    id
    userId
    isPayable
    hasOwnTransport
    address
    isMyWheelsUser
    hasFinishedOnboarding
  }
}
`);

type Output = {
    fieldworkerUpdate: (
        params: Omit<GqlFieldworkerUpdateInput, "userId">,
    ) => Promise<FetchResult<FieldworkerUpdateMutation>>;
    data: FieldworkerUpdateMutation | null | undefined;
    loading: boolean;
    error: ApolloError | undefined;
};

export default function useFieldworkerUpdate(
    userId: string,
    refetchQueries: (DocumentNode | TypedDocumentNode)[] = [ME_GET_USER_INFO],
): Output {
    const [fieldworkerUpdate, { data, loading, error }] = useMutation(FIELDWORKER_UPDATE, {
        refetchQueries,
    });

    return {
        fieldworkerUpdate: useCallback(
            (fieldworker: Omit<GqlFieldworkerUpdateInput, "userId">) => {
                return fieldworkerUpdate({
                    variables: {
                        input: {
                            userId,
                            ...fieldworker,
                        },
                    },
                });
            },
            [fieldworkerUpdate, userId],
        ),
        data,
        loading,
        error,
    };
}
